import "reflect-metadata"
import { injectable } from 'inversify-props'
import { MarketplaceServiceAdapter } from "@/usecases/marketplace/adapter/MarketplaceServiceAdapter"
import {
	findAll,
	findAllEdicaoEmMassa,
	findConfiguracoesPorLoja,
	updateConfiguracao,
	validarTokenParaLogin,
	validarRefreshToken,
	findAllAtributos,
	findAllCategoriasGlobais,
	findAllCanaisDeVenda,
	getProduto,
	updateProduto,
	updateProdutosEmMassa,
	createProduto,
	integrarProdutos,
	atualizarSincronizacaoProduto,
	validaProdutoExistente,
	findAllPedidos,
	integrarPedidos,
	findPedidoByVendaId,
	importarArquivoConfiguracao,
	buscarTaxasCanaisVenda,
	criarTaxaCanalVenda,
	atualizarTaxaCanalVenda,
	deletarTaxaCanalVenda,
	aplicarTaxaAosProdutos,
} from "@/api/marketplace"
import { AxiosRequestConfig } from "axios"
import { ConfiguracoesMarketplace, ImportacaoArquivoConfiguracao, ProdutoMarketplace, TaxaCanalVendaPlug4market } from "@/models"

@injectable()
export class MarketplaceService implements MarketplaceServiceAdapter {
	findAll = async (lojaId: string, params: any, config?: AxiosRequestConfig) => await findAll(lojaId, params, config)
	findAllEdicaoEmMassa = async (lojaId: string, params: any, config?: AxiosRequestConfig) => await findAllEdicaoEmMassa(lojaId, params, config)
	findConfiguracoesPorLoja = async (lojaId: string) => await findConfiguracoesPorLoja(lojaId)
	updateConfiguracao = async (configuracao: ConfiguracoesMarketplace) =>  await updateConfiguracao(configuracao)
	importarArquivoConfiguracao = async (importacaoArquivoConfiguracao: ImportacaoArquivoConfiguracao) => await importarArquivoConfiguracao(importacaoArquivoConfiguracao)
	validarTokenParaLogin = async (configuracao: ConfiguracoesMarketplace) =>  await validarTokenParaLogin(configuracao)
	validarRefreshToken = async (configuracaoId: string, refreshToken: string) =>  await validarRefreshToken(configuracaoId, refreshToken)
	findAllAtributos = async (params: any, config?: AxiosRequestConfig) => await findAllAtributos(params, config)
	findAllCategoriasGlobais = async (params: any, config?: AxiosRequestConfig) => await findAllCategoriasGlobais(params, config)
	findAllCanaisDeVenda = async (params: any, config?: AxiosRequestConfig) => await findAllCanaisDeVenda(params, config)
	getProduto = async (produtoId: string) => await getProduto(produtoId)
	updateProduto = async (produto: ProdutoMarketplace) => await updateProduto(produto)
	updateProdutosEmMassa = async (produtos: ProdutoMarketplace[]) => await updateProdutosEmMassa(produtos)
	createProduto = async (produto: ProdutoMarketplace) => await createProduto(produto)
	integrarProdutos = async (lojaId: string) => await integrarProdutos(lojaId)
	atualizarSincronizacaoProduto = async (produtoId: string, sincronizar: boolean) => await atualizarSincronizacaoProduto(produtoId, sincronizar)
	validaProdutoExistente = async (produtoId: string, lojaId: string) => await validaProdutoExistente(produtoId, lojaId)
	findAllPedidos = async (lojaId: string, params: any, config?: AxiosRequestConfig) => await findAllPedidos(lojaId, params, config)
	integrarPedidos = async (lojaId: string) => await integrarPedidos(lojaId)
	findPedidoByVendaId = async (vendaId: string) => await findPedidoByVendaId(vendaId)
	buscarTaxasCanaisVenda = async (configuracaoId: string) => await buscarTaxasCanaisVenda(configuracaoId)
	criarTaxaCanalVenda = async (configuracaoId: string, taxa: TaxaCanalVendaPlug4market) => await criarTaxaCanalVenda(configuracaoId, taxa)
	atualizarTaxaCanalVenda = async (configuracaoId: string, taxaId: string, taxa: TaxaCanalVendaPlug4market) => await atualizarTaxaCanalVenda(configuracaoId, taxaId, taxa)
	deletarTaxaCanalVenda = async (configuracaoId: string, taxaId: string) => await deletarTaxaCanalVenda(configuracaoId, taxaId)
	aplicarTaxaAosProdutos = async (configuracaoId: string, taxaId: string) => await aplicarTaxaAosProdutos(configuracaoId, taxaId)
}